/**
 * @module Helpers/Cart
 * @desc Cart Helpers
 */

import { CART_SHIPPING_MODEL_VIEW, Utilities, type Cart } from 'core/domains';

const MINIMUM_ORDER = 100;

/**
 * Presentation logic: Sets true if the cart has reached the minimum value
 *
 */
export function canSubmit(state: Cart) {
  const { minOrderPercentReachedNum } = state.data;

  return Number(minOrderPercentReachedNum) >= MINIMUM_ORDER && !isCartRunning(state);
}

/**
 * Keep the isRunning state based on async flow race conditions
 *
 */
export function isCartRunning(state: Cart) {
  return [state.fetch, state.itemUpdate].some(({ status }) => status === Utilities.STATUS.RUNNING);
}

/**
 * Presentation logic: Sets true if the shipping model is already selected by step
 *
 */
export function canSubmitShippingModel(state: Cart): boolean {
  const { businessModelCode, distributionCenterCode } = state.current.shippingModel;

  const validate: { [key: string]: boolean } = {
    [CART_SHIPPING_MODEL_VIEW.OPTIONS]: !!businessModelCode,
    [CART_SHIPPING_MODEL_VIEW.SELECT_PICKUP_STORE]: !!businessModelCode && !!distributionCenterCode,
  };

  return validate[state.step as string] || false;
}
